import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-no-pick-active-dialog',
  templateUrl: './no-pick-active-dialog.component.html',
  styleUrls: ['./no-pick-active-dialog.component.scss']
})
export class NoPickActiveDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NoPickActiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatDialog) { }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit() {
  }

}
